export default __webpack_public_path__ + "static/media/brand-10.ad486cfb.png";